// extracted by mini-css-extract-plugin
module.exports = {"button":"PagesPcon_button__2HEJ1","buttonsRow":"PagesPcon_buttonsRow__5DxgQ"};